module.exports = __webpack_public_path__ + "static/2020德勤明日之星-d344f5a1a9c76b0b723661fb1fa2f51c.jpg";